<template>
  <van-tabbar v-model="active" fixed safe-area-inset-bottom>
    <van-tabbar-item to="/?event=首页" :icon="active === 0 ? 'wap-home' : 'wap-home-o'">首页</van-tabbar-item>
    <van-tabbar-item to="/shop?event=商城" :icon="active === 1 ? 'shop' : 'shop-o'">商城</van-tabbar-item>
    <van-tabbar-item to="/shoppingCar?event=购物车" :badge="shoppingCarCount || ''" :icon="active === 2 ? 'shopping-cart' : 'shopping-cart-o'"
      >购物车</van-tabbar-item
    >
    <van-tabbar-item to="/mine?event=个人中心">
      <span>我的</span>
      <template #icon="props">
        <img :src="props.active ? require('../../assets/images/mineS.png') : require('../../assets/images/mine.svg')" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { mapState } from 'vuex'
let path = {
  '/': 0,
  '/shop': 1,
  '/shoppingCar': 2,
  '/mine': 3
}
export default {
  data() {
    return {
      active: 0,
      icon: {
        active: 'https://img.yzcdn.cn/vant/user-active.png',
        inactive: 'https://img.yzcdn.cn/vant/user-inactive.png'
      }
    }
  },
  computed: {
    ...mapState(['shoppingCarCount'])
  },
  watch: {
    $route(n) {
      // console.log(n)
      this.active = path[n.path]
    }
  },
  mounted() {
    let fullPath = this.$route.fullPath
    this.active = path[fullPath]
  }
}
</script>

<style lang="scss" scoped>
.van-tabbar-item--active {
  color: rgb(48, 136, 197);
}
</style>
